import axios from 'axios';
import apiConfig from '../api.config';

export default function getCheckInSubscriptionStatus({ hotelId }) {
  const {
    host,
    URIs: { checkinSuscriptionStatus },
  } = apiConfig;

  const uri = `${host}${checkinSuscriptionStatus.replace(':hotelId', hotelId)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data?.suscription || false;
    }).catch(err => {
      console.error(err);
      return false;
    });
}
